// Action Types
export const SET_CHARACTER_HISTORY = 'SET_CHARACTER_HISTORY';
export const SHOW_CHARACTER_HISTORY_LOADING_SPINNER = 'SHOW_CHARACTER_HISTORY_LOADING_SPINNER';

// Action Creator
const CharacterHistoryActionCreator = {
  setCharacterHistory(history: any) {
    return {
      type: SET_CHARACTER_HISTORY,
      payload: history
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_CHARACTER_HISTORY_LOADING_SPINNER,
      payload: show
    };
  }
};

export default CharacterHistoryActionCreator;
